import DataFeedDispatcher from '../dispatcher/DataFeedDispatcher';
import DataFeedConstants from '../constants/DataFeedConstants';

var DataFeedActions = {
    editOrganisation: function (values) {
        DataFeedDispatcher.dispatch({
            actionType: DataFeedConstants.EDIT_ORGANISATION,
            data: values
        })
    },
    setPileCheckToLoadType: function (type) {
        DataFeedDispatcher.dispatch({
            actionType: DataFeedConstants.SET_PILE_CHECK_TO_LOAD_TYPE,
            data: type
        })
    },
    processUnapproved: function () {
        DataFeedDispatcher.dispatch({
            actionType: DataFeedConstants.PROCESS_UNAPPROVED
        })
    },
    removeFromPile: function (orgID) {
        DataFeedDispatcher.dispatch({

            actionType: DataFeedConstants.REMOVE_FROM_PILE,
            data: orgID
        })
    },

    setNoMoreToProcess: function () {

        DataFeedDispatcher.dispatch({

            actionType: DataFeedConstants.SET_NO_MORE_TO_PROCESS
        })
    },

    storeUnapprovedPile: function (unapprovedPile) {

        DataFeedDispatcher.dispatch({

            actionType: DataFeedConstants.STORE_UNAPPROVED_PILE,
            data: unapprovedPile
        })
    },

    loadNonApprovedForPile: function () {

        DataFeedDispatcher.dispatch({

            actionType: DataFeedConstants.LOAD_NON_APPROVED_FOR_PILE
        })
    },

    storeContractors: function (contractors) {

        DataFeedDispatcher.dispatch({

            actionType: DataFeedConstants.STORE_CONTRACTORS,
            data: contractors
        })
    },

    setContractorToViewDataFor: function (contractorID) {

        DataFeedDispatcher.dispatch({

            actionType: DataFeedConstants.SET_CONTRACTOR_TO_VIEW_DATA_FOR,
            data: contractorID
        })
    },

    setOrganisationTypeToView: function (option) {

        DataFeedDispatcher.dispatch({

            actionType: DataFeedConstants.SET_ORGANISATION_TYPE_TO_VIEW,
            data: option
        })
    },

    loadContractors: function () {

        DataFeedDispatcher.dispatch({

            actionType: DataFeedConstants.LOAD_CONTRACTORS
        })
    },

    getOrganisation: function () {

        DataFeedDispatcher.dispatch({

            actionType: DataFeedConstants.GET_ORGANISATION

        });

    },

    setOrganisation: function () {

        DataFeedDispatcher.dispatch({

            actionType: DataFeedConstants.SET_ORGANISATION

        });
    },

    setLoading: function (isLoading) {

        DataFeedDispatcher.dispatch({

            actionType: DataFeedConstants.SET_LOADING,
            data: isLoading

        });
    }
};

export default DataFeedActions;



// WEBPACK FOOTER //
// ./resources/assets/js/data-feed/actions/DataFeedActions.js